/* eslint-disable prefer-promise-reject-errors */
import jwt from 'jsonwebtoken';
import axios from 'axios';

import { differenceInMinutes } from 'date-fns';
import { ConfigApi } from '../config/Constantes';
import authConfig from '../config/auth';
// eslint-disable-next-line import/no-cycle
import { store } from '../store';
import { logout } from '../store/modules/auth/actions';

// import AuthService from './AuthService';

function checkToken(token) {
  try {
    jwt.verify(token, authConfig.secret);
    return true;
  } catch (error) {
    return false;
  }
}

const api = axios.create({
  baseURL: ConfigApi.baseURL,
});

// configurando a api
api.interceptors.request.use(
  config => {
    const { Authorization } = config.headers;
    const { url } = config;
    if (Authorization && url !== 'sessions') {
      const token = Authorization.split(' ')[1];
      if (token && !checkToken(token)) {
        return Promise.reject({ tokenExpired: true });
      }

      if (url !== 'apiInfo') {
        checkApi();
      }
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    return Promise.reject(error);
  }
);

export async function checkApi() {
  const check = await checkVersaoApi();

  if (!check) {
    // window.location = '/login';
    store.dispatch(logout());
  }
}

export async function getApiInfo() {
  try {
    const response = await api.get(`${ConfigApi.apiInfoURL}`);
    return response.data;
  } catch (err) {
    return null;
  }
}

export async function checkVersaoApi() {
  let retorno = true;

  try {
    const dataAtual = new Date();

    // const versaoApi = Number(localStorage.getItem('apiVersion') || '0');
    // const dataUltimaVersao = localStorage.getItem('dateLastUpdate');
    const apiInfo = JSON.parse(localStorage.getItem('apiInfo'));
    const dataUltimaVersao = apiInfo && apiInfo.dateLastUpdate ? apiInfo.dateLastUpdate : null;
    const versaoApi = Number(apiInfo ? apiInfo.apiVersion : '0');

    let versao = versaoApi;
    let atualizarApiInfo = false;
    const ultimaData =
      new Date(dataUltimaVersao).toString() !== 'Invalid Date'
        ? new Date(dataUltimaVersao)
        : null;

    if (!ultimaData || Math.abs(differenceInMinutes(ultimaData, dataAtual)) >= 1) {
      const data = await getApiInfo();
      versao = data.versionNumber;
      atualizarApiInfo = true;
    }

    if (versaoApi !== versao) {
      atualizarApiInfo = true;
      retorno = false;
    }
    if (atualizarApiInfo) {
      localStorage.setItem(
        'apiInfo',
        JSON.stringify({
          apiVersion: versao,
          dateLastUpdate: dataAtual,
        })
      );
    }
  } catch (err) {
    // toast.error('Não foi possível obter versão da API');
  }

  return retorno;
}

export default api;
